window.bvCallback = function (BV) {
    if (typeof BV !== 'undefined') {
        BV.reviews.on('show', function () {
            // This line assumes SFRA collapsible panels and is called when clicking on the review summary
            $('.row.reviews:not(.active)').toggleClass('active');
        });
        if (BV.questions) {
            BV.questions.on('show', function () {
                // This line assumes SFRA collapsible panels and is called when clicking on the Q&A summary
                $('.row.questions:not(.active)').toggleClass('active');
            });
        }
    }
};

setTimeout(function () {
    var $bvShowElement = $('#data-bv-show');

    if ($bvShowElement.length !== 0) {
        $bvShowElement.removeClass('bv-hidden');
    }
}, 1500);

$('body').on('product:afterAttributeSelect', function (e, response) {
    const productType = $('.js-product').data('product-type');

    if (response.container && !$(response.container).hasClass('product-quickview') && productType !== 'productSet') {
        $('div[data-bv-product-id]').attr('data-bv-product-id', response.data.product.id);
    }
});
